module.exports = __webpack_public_path__ + "static/img/a106.26316c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a106.jpg
// module id = Xjz+
// module chunks = 0